import React from 'react'

import { useQuery } from '@apollo/client'
import query from './query.graphql'

const withQuery = WrappedComponent => {
  return props => {
    const {
      onQueryError, // via withQueryResults
      onLoggedInQueryCompleted // via withQueryResults
    } = props

    // react hooks
    const {
      loading: queryLoading,
      error: queryError,
      data: queryData
    } = useQuery(query, {
      onError: onQueryError,
      onCompleted: onLoggedInQueryCompleted
    })

    // GraphQL data
    const {
      viewer: account,
      seasons,
      allergies,
      dietaryRestrictions
    } = queryData || {}

    const season = seasons ? seasons[0] : null

    return (
      <WrappedComponent
        queryLoading={queryLoading}
        queryError={queryError}
        allergies={allergies || []}
        dietaryRestrictions={dietaryRestrictions || []}
        season={season}
        account={account}
        {...props}
      />
    )
  }
}

export default withQuery
